<script>
import GuestDocumentationMixin from '@/mixins/guestdocumentation'
import IconPlay from '@/components/IconPlay.vue'

import { SELLING_REGIONS } from '@/constants'

import { helpers } from '@/helpers.js'

export default {
  name: 'GuestDocumentationInsightVacations',
  mixins: [ GuestDocumentationMixin ],
  computed: {},
  data () {
    return {
      isModalTermsAndConditionsToggle: false,
      constants: {
        SELLING_REGIONS
      }
    }
  },
  methods: {
    isInvalidContent (field = '') {
      return helpers.isInvalidContent(field)
    },
    toggleTermsAndConditionsModal () {
      this.isModalTermsAndConditionsToggle = !this.isModalTermsAndConditionsToggle
      document.body.classList.toggle('modal-open', this.isModalTermsAndConditionsToggle)
    },
    muted () {
      var video = document.getElementById('videoLoop')
      video.muted = true
    },
    scrollMeTo (refName) {
      var element = document.getElementById(refName)
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: 'smooth'
      })
    },
    scrollMeDay (dd) {
      var element = document.getElementById(dd)
      var modal = document.getElementById('modal-fullscreen')
      modal.scrollTo({
        top: element.offsetTop,
        behavior: 'smooth'
      })
    }
  },
  components: {
    IconPlay
  }
}
</script>

<style lang="scss" scoped>
@import './font-effra.scss';
@import './font-fontawesome.scss';
@import './bootstrap.scss';
@import './main.scss';
@import './style-1.scss';
@import './print.scss';
</style>
<template>
  <div id="menu" class="body-page fp-viewing-home body" :class="{ 'modal-open': isModalToggle }">
    <!-- BEGIN OF site header Menu -->
    <header class="page-header navbar page-header-drawer menu-right logo-left topmenu-right animated slow fadeIn hidePlease">

      <!-- Begin of menu icon toggler -->
      <button class="navbar-toggler site-menu-icon" id="navMenuIcon" :class="{ 'menu-visible': isMenuToggle }" @click="toggleMenu" v-if="showCover">
        <span class="menu-icon menu-icon-line" :class="{ 'menu-visible': isMenuToggle }">
          <span class="text show-menu-visible" :class="{ 'menu-visible': isMenuToggle }">Close</span>
          <span class="text hide-menu-visible" :class="{ 'menu-visible': isMenuToggle }">Menu</span>
          <span class="bars">
            <span class="bar1"></span>
            <span class="bar2"></span>
            <span class="bar3"></span>
          </span>
        </span>
      </button>

      <div class="cover-tittle">
        <div class="cover-logo">
          <a class="navbar-brand" href="#">
            <span class="logo">
              <img v-if="d.itineraries.sellingregions[0].id == constants.SELLING_REGIONS.US.id" class="light-logo" src="/guestdocumentation/insight-vacations/img/logo.png" alt="Logo">
              <img v-else class="light-logo" src="/guestdocumentation/insight-vacations/img/logo2.png" alt="Logo">
            </span>
          </a>
        </div>
        <div class="cover-note">
          <ul>
            <li>INSIGHT EXPERIENCES</li>
            <li>DELICIOUSLY AUTHENTIC DINING</li>
            <li>TRAVEL AND STAY IN STYLE </li>
            <li>SMALLER GROUP CAMARADERIE</li>
            <li>SEAMLESS, STRESS-FREE TRAVEL</li>
          </ul>
        </div>
      </div>

      <div class="all-menu-wrapper" id="navbarMenu" :class="{ 'menu-visible': isMenuToggle }">
        <nav class="navbar-mainmenu">
          <div class="mainmenu-bg" @click="toggleMenu"></div>
          <div class="mainmenu-content">
            <ul class="navbar-nav">
              <li class="nav-item active">
                <a class="nav-link" href="#home" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('home')">Home
                  <span class="sr-only">(current)</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#letter" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('letter')">Description</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#itinerary" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('itinerary')">Itinerary</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#highlight" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('highlight')">Highlights</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#map" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('map')">Map</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#prices" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('prices')">Pricing</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#contact" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('contact')">Contact Us</a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
    <!-- END OF site header Menu-->

    <!-- BEGIN OF page main content -->
    <main class="page-main main-anim scrollpage-container" id="mainpage">
      <div
        id="home"
        class="backgroundHome section section-home fullscreen-md main-home section-center content-black bg-level-1"
        data-section="home"
        :style="[firstOpporunityBackgroundImage != ''
                  ? {
                    backgroundImage: `url('${getParsedImageUrl(
                      firstOpporunityBackgroundImage
                    )}')`
                  } : {'background-image': 'url(/guestdocumentation/insight-vacations/img/bg-style-1.jpg)'}]">
        <div class="fullscreen-video-wrap" v-if="!showCover">
          <button class="button button-play" type="button" id="firstPlayVideo" @click="playVideo"></button>
          <button type="button" class="btn btn-link animated fadeIn slow" id="firstSkipVideo" @click="skipVideo"><div>Skip video <IconPlay/></div></button>
          <div class="overlay-home"></div>
          <video
            allow='autoplay'
            preload="auto"
            playsinline
            id="videoLoop"
            class="animated fadeIn videoDesktop"
            poster="/guestdocumentation/insight-vacations/video/video.jpg">
            <source src="https://dkbr8tla2pux3.cloudfront.net/images/weblink/insight-vacations/video/video.mp4" type="video/mp4"></video>
        </div>
        <div class="section-wrapper animated delay-1s slow fadeIn">
          <div class="section-content anim">
            <div class="row">
              <div class="col-12 col-md-12 text-left">

                <div class="cover-header-description" v-show="showCover">
                  <div class="location" v-if="Array.isArray(d.itineraries.locations_visited) == true">
                    <i class="fa fa-map-marker" ></i>
                    <span v-if="d && d.itineraries && d.itineraries.locations_visited && Array.isArray(d.itineraries.locations_visited)">{{ d.itineraries.locations_visited | custom-join('name') }}</span>
                  </div>
                  <div class="cover-slider-description">
                    <h1 class="cover-header-description-title1">
                      <i class="icon fa fa-calendar"></i>
                      <span class="text-uppercase" v-if="d && d.itineraries">{{ d.itineraries.fromitinerary | custom-date }}</span>
                      <i class="fa fa-arrow-right ml-2"></i>
                      <i class="icon fa fa-calendar"></i>
                      <span class="text-uppercase" v-if="d && d.itineraries">{{ d.itineraries.toitinerary | custom-date }}</span>
                    </h1>
                    <div class="cover-header-description-title2" v-if="d && d.guest_documentation">
                      {{ d.guest_documentation.trip_name }}
                    </div>
                    <div class="cover-header-description-title3" v-if="d && d.guest_documentation">
                        <span>GUEST DOCUMENTATION</span>
                    </div>
                  </div>
                </div>

                <div class="btn-trip form-group form-success-gone mb-0" v-show="!showCover">
                  <button id="submit-email" name="submit_email" class="btn-trip_white animated fadeInDown slow animatedColor btn form-success-gone mb-0 hidePlease" @click="toggleCover">
                    <strong class="text">VIEW TRIP</strong>
                  </button>
                   <button id="submit-email" name="submit_email" class="btn-trip_main animated fadeIn slow btn form-success-gone mb-0 hidePlease" @click="toggleCover">
                    <strong class="text">VIEW TRIP</strong>
                  </button>
                </div>
              </div>

            </div>
          </div>

          <footer class="section-footer scrolldown" v-show="showCover">
            <a class="down" @click="scrollMeTo('letter')">
              <span class="icon"></span>
              <span class="txt">INTRODUCTION</span>
            </a>
          </footer>
        </div>
      </div>

      <!-- Begin of grid list section -->
      <div class="section fl-porto" data-section="letter" id="letter" v-show="showCover">
        <div>
          <div class="row letter_flexbox">
            <div class="letter-column text-left section-wrapper with-margin padding-desktop">
              <!-- title and description -->
              <div class="title-desc anim-4 padding-container2"><button class="button_print"><i class="fa fa-print"></i>Print</button></div>
                 <div class="padding-container2">
                 <!--PRINT: INTRODUCTION-->
                   <table id="print-header" class="print-only">
                      <tbody>
                         <tr>
                            <td width="70%">
                               <h1 class="title_trip_info">TRIP<br> INFORMATION</h1>
                            </td>
                            <td width="10%"></td>
                            <td class="total-value" width="20%">
                               <div id="logo" class="logo_print">
                                <img v-if="d.itineraries.sellingregions[0].id == constants.SELLING_REGIONS.US.id" class="light-logo" src="/guestdocumentation/insight-vacations/img/logo_print.png" alt="Logo">
                                <img v-else class="light-logo" src="/guestdocumentation/insight-vacations/img/logo2_print.png" alt="Logo">
                               </div>
                            </td>
                         </tr>
                         <tr>
                            <td width="70%" v-if="d && d.guest_documentation">
                              <div class="border-trip-name">
                               <h4>{{ d.guest_documentation.trip_name }}</h4>
                              </div>
                            </td>
                            <td width="10%"></td>
                            <td class="trip-code-section" width="20%">
                              <div class="print_info_it">
                                <p id="trip-code-number-section">TRIP CODE<strong id="trip-code">IXCF0292GL01</strong></p>
                                <p id="trip-date-section">TRIP DATE<strong id="trip-code">25/11/2020</strong></p>
                               </div>
                            </td>
                         </tr>
                      </tbody>
                   </table>
                 <!--PRINT: INTRODUCTION-->
                  </div>
                  <div class="title-desc anim-4 padding-container2 pt-4"
                  v-html="d.guest_documentation.short_description"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- End of grid list section -->

      <!-- Begin of grid list section -->
      <div class="section bg-level-2" data-section="itinerary" id="itinerary" v-show="showCover">
        <div class="section-wrapper with-margin">
          <div class="section-content anim padding-container">
            <div class="section-tittle">
              <div class="cover-header-description-title2 scrolled">Your Travel Itinerary</div>
                     <div class="title-print"><h1 class="display-5 anim-2 h2 mb-4">Your Travel Itinerary</h1></div>
              <div class="cover-header-description-title3" v-if="d && d.guest_documentation">
                {{ d.guest_documentation.trip_name }}
              </div>
              <div class="cover-header-description-title4">
                <i class="icon fa fa-calendar"></i>
                <span class="text-uppercase" v-if="d && d.itineraries">{{ d.itineraries.fromitinerary | custom-date }}</span>
                <i class="fa fa-arrow-right"></i>
                <i class="icon fa fa-calendar"></i>
                <span class="text-uppercase" v-if="d && d.itineraries">{{ d.itineraries.toitinerary | custom-date }}</span>
                <i v-if="d && d.itineraries && d.itineraries.locations_visited && Array.isArray(d.itineraries.locations_visited)" class="fa fa-map-marker"></i>
                <span v-if="d && d.itineraries && d.itineraries.locations_visited && Array.isArray(d.itineraries.locations_visited)">{{ d.itineraries.locations_visited | custom-join('name') }}</span>
              </div>
            <!--PRINT: YOUR TRAVEL ITINERARY-->
            <table id="days-box">
              <tbody>
                 <tr :id="`day${index}`" v-for="(day, index) in d.itineraries.days" :key="index">
                    <td width="100%">
                       <h4 class="title-day-date">DAY {{ index + 1}}<span class="title-day">ARRIVE LONDON.</span></h4>
                        <p v-if="day && day.textday && day.textday[0] && day.textday[0].textday" v-html="day.textday[0].textday"></p>
                        <p v-if="day.meals">
                          <strong class="mr-1">MEAL(S):</strong>
                          <span>{{ day.meals | custom-join('mealsday') }}</span>
                        </p>
                        <p v-if="day.accommodation">
                        <strong class="mr-1">ACCOMMODATION:</strong>
                        <span>{{ day.accommodation}}</span>
                      </p>

                    </td>
                 </tr>
              </tbody>
            </table>
            <!--PRINT: YOUR TRAVEL ITINERARY-->
            </div>
            <div class="row row-random grid-media-aside-text fade-3 no-print">
                <div class="col-md-4 border-card" v-for="(day, index) in d.itineraries.days" :key="index" @click="dayScrollTo(index)">
                  <div class="card gallery-day" data-toggle="modal" data-target="#modal-fullscreen">
                    <img v-if="day.url_image_1200_725" :src="day.url_image_1200_725"/>
                    <img v-if="!day.url_image_1200_725" src="/guestdocumentation/insight-vacations/img/day-img.jpg"/>
                    <div class="info">
                      <h1>day {{ day.startday }}</h1>
                      <p v-html="day.title"></p>
                      <p>
                        <i class="icon fa fa-calendar mr-2"></i>
                        <span class="text-uppercase" v-if="day">{{ day.startdate | custom-date }}</span>
                      </p>
                      <p v-if="day && day.locations && Array.isArray(day.locations)" class="location mt-2">
                        <i class="fa fa-map-marker mr-2"></i>
                        <span >{{ day.locations | custom-join('name') }}</span>
                      </p>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End of grid list section -->

      <!-- Begin of description section -->
      <!-- <div class="section fullscreen-md-off bg-level-3 no-footer bg-mark" data-section="map" id="map" v-show="showCover"> -->
      <div class="section fullscreen-md-off bg-level-3 no-footer bg-mark" data-section="highlight" id="highlight" v-show="showCover"
        v-if="Array.isArray(d.guest_documentation.highlights) && d.guest_documentation.highlights.length > 0 ||
        Array.isArray(d.guest_documentation.whatsincluded) && d.guest_documentation.whatsincluded.length > 0">

        <img v-if="secondOpporunityBackgroundImage != ''" :src="`${getParsedImageUrl(secondOpporunityBackgroundImage)}`" alt="">
        <img v-else src="/guestdocumentation/insight-vacations/img/bg-style-2.jpg" alt="">
        <div class="section-wrapper with-margin">
          <div class="section-content anim padding-container">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="title-desc">
                  <h2 class="display-5 anim-2 no-print">Map</h2>
                  <div class="title-print print-only"><h2 class="display-5 anim-2">Map</h2></div>
                </div>
              </div>
              <div class="col-12 col-md-12">
                <div class="section-maps">
                  <Map :locations="locationsVisited" />
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End of description section -->

      <div class="section section-register bg-level-2 section-map" data-section="highlight" id="highlight" v-show="showCover">
        <div class="section-wrapper with-margin section-hotel">
          <div class="section-content anim padding-container">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="section-info white"
                v-if="Array.isArray(d.guest_documentation.highlights) && d.guest_documentation.highlights.length > 0">
                  <h1 class="display-5 anim-2 h2 mb-4">Hotel List</h1>
                  <div class="title-print"><h1 class="display-5 anim-2 h2 mb-4">Hotel List</h1></div>
                  <div class="section-column">
                    <div class="table">
                     <table>
                        <tbody>
                           <tr>
                              <td><strong>Hotel Kaiserhof Wien</strong><br><strong>02-Aug-19 / 04-Aug-19 / Vienna</strong><br>Frankenberggasse 10, Vienna, Austria,<br>T: 43 1 5051701</td>
                           </tr>
                           <tr>
                              <td><strong>Vila Bled Hote</strong><br><strong>04-Aug-19 / 06-Aug-19 / Bled</strong><br>Cesta Svobode 26, Bled, Slovenia, 4260<br>T: 386 4 5753710</td>
                           </tr>
                           <tr>
                              <td><strong>Grand hotel Union Executive Ljubljana</strong><br><strong>06-Aug-19 / 09-Aug-19 / Ljubljana</strong><br>Miklošičeva cesta 1, 1000 Ljubljana, Slovenia<br>T: 386 1 3081270</td>
                           </tr>
                           <tr>
                              <td><strong>Imlauer and Brau Hotel Salzburg</strong><br><strong>09-Aug-19 / 11-Aug-19 / Salzburg</strong><br>Rainerstrasse 12 14, Salzburg, Austria, 5020<br>T: 43 662 88992&nbsp;</td>
                           </tr>
                           <tr>
                              <td><strong>Austria Trend Hotel Schloss Lebenberg</strong><br><strong>11-Aug-19 / 14-Aug-19 / Kitzbuehl</strong><br>Lebenbergstrasse 17, Kitzbuehl, Austria, 6370<br>T: 43 5356 6901</td>
                           </tr>
                           <tr>
                              <td><strong>Steigenberger Hotel Drei Mohren Augsburg</strong><br><strong>14-Aug-19 / 16-Aug-19 / Augsburg</strong><br>Maximilianstrasse 40, Augsburg, germany, 86150<br>T: 49 821 50360&nbsp;</td>
                           </tr>
                           <tr>
                              <td><strong>Maritim Titisee Hotel</strong><br><strong>16-Aug-19 / 19-Aug-19 / Titisee</strong><br>Seestrasse 16, Titisee, Germany, 79822<br>T: 49 7651 8080&nbsp;</td>
                           </tr>
                           <tr>
                              <td><strong>Steffani Hotel St Moritz</strong><br><strong>19-Aug-19 / 20-Aug-19 / St Moritz</strong><br>Sonnenplatz, St Moritz, Switzerland, CH 7500<br>T: 41 81 8369696</td>
                           </tr>
                           <tr>
                              <td><strong>Resort Grand Hotel Alex Zermatt Switzerland</strong><br><strong>20-Aug-19 / 21-Aug-19 / Zermatt</strong><br>Bodmenstrasse 12, Zermatt, Switzerland, 3920<br>T: 41 27 9667070&nbsp;</td>
                           </tr>
                           <tr>
                              <td><strong>Beau Rivage Hotel Interlaken</strong><br><strong>21-Aug-19 / 23-Aug-19 / Interlaken</strong><br>Hoheweg 211, Interlaken, Switzerland, 3800<br>T: 41 33 8267007&nbsp;</td>
                           </tr>
                           <tr>
                              <td><strong>Gaia Hotel</strong><br><strong>23-Aug-19 / 24-Aug-19 / Basel</strong><br>Centralbahnstrasse 13, Basel, Switzerland, 4002<br>T: 41 61 2251313&nbsp;</td>
                           </tr>
                        </tbody>
                     </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Begin of description section -->
      <!-- Begin of contact section -->
      <div class="section bg-level-3 bg-mark" data-section="contact" id="contact" v-show="showCover" v-if="!isInvalidContent(d.guest_documentation.optional_experience)">
        <img v-if="thirdOpporunityBackgroundImage != ''" :src="`${getParsedImageUrl(thirdOpporunityBackgroundImage)}`" alt="">
        <img v-else src="/guestdocumentation/insight-vacations/img/bg-style-1.jpg" alt="">
        <div class="section-wrapper with-margin">
            <div class="section-content padding-container">
              <div class="row">
                <div class="col-12 col-md-12 anim">
                    <div class="section-info white">
                     <h1 class="display-5 anim-2 h2 mb-4">Optional Experiences</h1>
                     <div class="title-print"><h1 class="display-5 anim-2 h2 mb-4">Optional Experiences</h1></div>
                    <!--Example-->
                    <p dir="ltr"><strong>Your trip already includes a host of bonus highlights and comprehensive sightseeing. However, there is an exciting array of optional experiences which will turn an already amazing experience into the trip of a lifetime! These are entirely optional and can be booked through your Travel Director/Local Host at the commencement of your trip. In many cases, optional experiences will be priced in the local currency (or USD) but please read through the details of individual optional experiences below for specific information. Exact payment options will be advised locally by your Travel Director/Local Host for each optional experience, but in many cases cash, Visa, Mastercard and American Express are all accepted. Please be sure to advise your credit card provider that you will be travelling in Europe/North Africa, before you leave home. Children 15 and under are entitled to a 25% discount on all European operated optional experiences</strong> <i>(some Eastern Mediterranean trips excluded)</i>.</p>
                      <br>
                      <p><strong>AMSTERDAM </strong><span style="font-weight: 400;">DINNER IN A HISTORIC DUTCH</span> <span style="font-weight: 400;">RESTAURANT &amp; CANAL CRUISE</span></p>
                      <p><span style="font-weight: 400;">Savour a meal of typical Dutch specialities with drinks in historic surroundings. Later we board our private canal boat and glide gently along illuminated canals, past traditional Dutch-gabled houses built right on the water's edge and under picturesque bridges.</span></p>
                      <p><strong>Adult Price: </strong><span style="font-weight: 400;">EUR 69.00</span></p>
                      <p><strong>Code: </strong><span style="font-weight: 400;">AMS0006</span></p>
                      <br>
                      <p><strong>PARIS </strong><span style="font-weight: 400;">SEINE CRUISE AND ILLUMINATIONS</span></p>
                      <p>The City of Light really lives up to its name when the monuments, buildings and bridges are lit up in all their glory. First, a specially designed sightseeing boat takes us for an unforgettable cruise along the Seine and beneath famous bridges to appreciate the Left and Right Banks and the Île de la Cité &amp; St Louis. Then, with a Local Expert, we'll enjoy an illuminations tour, when the rubies &amp; diamonds of the Champs Élysées and the Eiffel Tower are at their magnificent best.</p>
                      <p><strong>Adult Price: </strong><span style="font-weight: 400;">EUR 38.00</span></p>
                      <p><strong>Code: </strong><span style="font-weight: 400;">PAR0006</span></p>
                      <br>
                      <p><strong>PARIS </strong><span style="font-weight: 400;">NOUVELLE EVE DINNER AND CABARET</span></p>
                      <p>One of the oldest and most elegant revue theatres in Paris, Nouvelle Eve is a hidden gem where you'll meet the Director and two of the cast members before enjoying a four-course dinner with wine. You will then experience unparalleled Parisian entertainment – including the world-famous Can-Can.</p>
                      <p><strong>Adult Price: </strong><span style="font-weight: 400;">EUR 139.00</span></p>
                      <p><strong>Code: </strong><span style="font-weight: 400;">PAR0013</span></p>
                      <br>
                      <p>Many Optional Experiences are operated by independent third party suppliers, not Insight Vacations. Occasionally these
                         experiences involve outdoor activities and/or can be physically demanding. You should make your own decisions about these
                         experiences and only participate in activities that you feel are suited to your own physical ability. We recommend you check
                         that the insurance you have taken out also includes your participation in any activities you may/will undertake during your
                         overall trip. Please Note: Optional Experiences can only operate with the minimum number of participants required.
                      </p>
                    <!--Example-->
                    </div>
                </div>
              </div>
            </div>
          </div>
      </div>

      <footer v-show="showCover">
        <div class="section-wrapper padding-footer ">
          <div class="powered-by-text">
            Powered by<br>
            <img src="/guestdocumentation/insight-vacations/img/logo-itp.png" width="80">
          </div>
          <div class="detail">All rights reserved: ©Global Encounters™ 1999 - {{new Date().getFullYear()}}</div>
        </div>
      </footer>

    </main>

    <!-- Modal Fullscreen -- TERMS AND CONDITIONS -->
      <div
        class="modal modal-fullscreenTC fade"
        id="modal-terms-and-conditions-fullscreen" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
        :class="{ 'show': isModalTermsAndConditionsToggle }"
        :style="{ display: 'block', paddingRight: '16px' }"
        v-show="isModalTermsAndConditionsToggle">
        <div class="section-header">
          <button
            type="button" class="close" data-dismiss="modal" aria-hidden="true"
            @click="toggleTermsAndConditionsModal"><i class="fa fa-times"></i></button>
        </div>
        <div class="modal-dialog animated fadeIn">
          <div class="modal-content">
            <div class="modal-body">
              <div class="title-desc"><h3 class="h2 dark-blue pt-3">Terms & Conditions</h3></div>
              <div
                class="title-desc anim-4 padding-container scrollable"
                v-html="d.guest_documentation.terms_conditions">
              </div>
            </div>
          </div>
        </div>
      </div>

    <!-- Modal Fullscreen -- DAYS-->
    <div
      class="modal modal-fullscreen fade modalDays animated fadeIn"
      id="modal-fullscreen" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
      :class="{ 'show': isModalToggle }"
      :style="{ display: 'block', paddingRight: '16px' }"
      v-show="isModalToggle">
      <div class="section-header">
        <img v-if="d.itineraries.sellingregions[0].id == constants.SELLING_REGIONS.US.id" class="light-logo" src="/guestdocumentation/insight-vacations/img/logo.png" alt="Logo">
        <img v-else class="light-logo" src="/guestdocumentation/insight-vacations/img/logo2.png" alt="Logo">
        <button
          type="button" class="close" data-dismiss="modal" aria-hidden="true"
          @click="toggleModal"><i class="fa fa-times"></i></button>
      </div>
      <div class="modal-dialog ">
        <div class="modal-content  ">
          <div class="modal-body">

            <div
              class="col-md-12 p-0 section-day p active"
              :id="`day${index}`"
              v-for="(day, index) in d.itineraries.days" :key="index">
              <div class="row">
                <div class="col-md-6 cover-image">
                  <img v-if="day.url_image_1600_900" :src="day.url_image_1600_900"/>
                  <img v-if="!day.url_image_1600_900" src="/guestdocumentation/insight-vacations/img/day-img.jpg"/>
                </div>
                <div class="col-md-6 section-text">
                  <div class="align-vcenter">
                    <h1>DAY {{ index + 1}}</h1>
                    <p class="subtittle" v-html="day.title"></p>
                    <p class="date">
                      <i class="icon fa fa-calendar mr-1"></i>
                      <span class="text-uppercase" v-if="day">{{ day.startdate | custom-date }}</span>
                    </p>
                    <p class="location mt-2" v-if="day && day.locations && Array.isArray(day.locations)" >
                      <i class="fa fa-map-marker mr-2"></i>
                      <span>{{ day.locations | custom-join('name') }}</span>
                    </p>
                    <p v-if="day && day.textday && day.textday[0] && day.textday[0].textday" v-html="day.textday[0].textday"></p>
                    <p v-if="day.meals">
                      <strong class="mr-1">MEAL(S):</strong>
                      <span>{{ day.meals | custom-join('mealsday') }}</span>
                    </p>
                    <p v-if="day.accommodation">
                      <strong class="mr-1">ACCOMMODATION:</strong>
                      <span>{{ day.accommodation}}</span>
                    </p>
                  </div>
                  <footer class="section-footer scrolldownDay nextday"
                  v-if="index != Object.keys(d.itineraries.days).length - 1">
                    <a class="down" @click="scrollMeDay(`day${index+1}`)">
                      <span class="txt">DAY {{ Number(day.startday) + 1 }}</span>
                    </a>
                  </footer>
                  <footer class="section-footer scrolldownDay nextday" v-else>
                    <a class="down" @click="scrollMeDay('day0')">
                      <span class="txt">DAY 1</span>
                    </a>
                  </footer>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>
